module.exports = __webpack_public_path__ + "img/5.2326c9f3.png";